import { render, staticRenderFns } from "./states_badge.vue?vue&type=template&id=740fa220&"
import script from "./states_badge.vue?vue&type=script&lang=js&"
export * from "./states_badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports